/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import moment from 'moment'
import 'moment/locale/pt';

import ReactExport from "react-export-excel";
import FilterModal from "./components/filterModal"
import DetailsClientModal from "./components/detailsClientModal"

import FixedContainer from '../../components/Container';
import { Box, Button, Modal, Typography, TextField, FormControl } from '@mui/material';
import LoadingComponent from '../../components/LoadingComponent';
import PaginationRounded from '../../components/NewPagination';
import CustomizedTables from '../../components/Table';
import NewClientModal from './components/newClientModal';
import OrderModal from './components/orderModal';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../services/apiBase';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ClientList = ({ history }) => {

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState(null);
  const [clientsExcel, setClientsExcel] = useState(null);
  const [clientsAttributes, setClientsAttributes] = useState(null);
  const [clientAmount, setClientAmount] = useState(null);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState(false);
  const [ordering, setOrdering] = useState(false);
  const [orderingValues, setOrderingValues] = useState('');
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalOrdering, setOpenModalOrdering] = useState(false);
  const [loadingClientAmount, setLoadingClientAmount] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit] = useState(50);
  const [filterValues, setFilterValues] = useState('');
  const [query, setQuery] = useState('');
  
  const [availableClassifications, setAvailableClassifications] = useState([{
    id: 0, name: 'NAO INFORMADO'
  }]);

  const COLUMNSTABLE = [
    {
      headerName: 'ID',
      type: 'default',
      value: {
        first: {
          value: 'id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Nome',
      type: 'default',
      value: {
        first: {
          value: 'name'
        }
      }
    },
    {
      headerName: 'Classificação',
      type: 'default',
      value: {
        first: {
          // parent: ["personne_classification"],
          value: 'personne_classification_name'
        },
      }
    },
    {
      headerName: 'E-mail',
      type: 'default',
      value: {
        first: {
          parent: ["emails"],
          value: 'email'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
    {
      headerName: 'Perfil',
      type: 'default',
      value: {
        first: {
          parent: ['personne_profile'],
          value: 'name'
        }
      }
    },
  ]

  const toggle = () => setModal(!modal);
  const toggleOpenModalNew = () => setOpenModalNew(!openModalNew);
  const toggleOpenModalOrdering = () => setOpenModalOrdering(!openModalOrdering);

  const handleOpen = () => {
    setOpenFilterModal(true)
    setFilter(false)
  }
  const handleClose = () => setOpenFilterModal(false);

  const handleClearFilter = () => {
    setFilter(false);
    setFilterValues('');
  }

  const handleClearOrder = () => {
    setOrdering(false);
    setOrderingValues('');
  }

  const handleCreateNewJson = async (clientsTest) => {
    let FinalClient = []

    for (var i = 0; i < clientsTest.length ; i ++ ){
      var cpf = "Não informado"
      var documento = []
      var telefone = []
      var email = []
      var rua = "Não informado"
      var numero = "Não informado"
      var cep = "Não informado"
      var cidade = "Não informado"
      var estado = "Não informado"
      if(clientsTest[i].documents.length > 0) {
        
        for (var j = 0; j < clientsTest[i].documents.length ; j ++ ){ 
          if (clientsTest[i].documents[j].type === 'CPF') {
            cpf = clientsTest[i].documents[j].document_number
          }
          if (clientsTest[i].documents[j].type !== 'CPF') {
            documento.push(clientsTest[i].documents[j])
          }
        }
      }
      if(clientsTest[i].addresses.length > 0) {
        for (var k = 0; k < clientsTest[i].addresses.length ; k ++ ){ 
          rua = clientsTest[i].addresses[k].name ? clientsTest[i].addresses[k].name : "Não informado"
          numero = clientsTest[i].addresses[k].number ? clientsTest[i].addresses[k].number : "Não informado"
          cep = clientsTest[i].addresses[k].postcode ? clientsTest[i].addresses[k].postcode : "Não informado"
          cidade = clientsTest[i].addresses[k].city.name_city ? clientsTest[i].addresses[k].city.name_city : "Não informado"
          estado = clientsTest[i].addresses[k].city.name_uf ? clientsTest[i].addresses[k].city.name_uf : "Não informado"
        }
      }
      if(clientsTest[i].phones.length > 0) {
        for (var l = 0; l < clientsTest[i].phones.length ; l ++ ){ 
          telefone.push(clientsTest[i].phones[l])
        }
      }
      if(clientsTest[i].emails.length > 0) {
        for (var m = 0; m < clientsTest[i].phones.length ; m ++ ){ 
          email.push(clientsTest[i].emails[m])
        }
      }
      FinalClient.push({
        id: clientsTest[i].id, 
        cpf, 
        name: clientsTest[i].name, 
        gender: clientsTest[i].gender ? clientsTest[i].gender : "Não informado",
        birth_date: clientsTest[i].birth_date ? moment.utc(clientsTest[i].birth_date).format('L') : "Não informado",
        rua,
        numero,
        cep,
        cidade,
        estado,
        documento,
        nationality: clientsTest[i].nationality ? clientsTest[i].nationality : "Não informado",
        profession: clientsTest[i].professions ? clientsTest[i].professions.name : "Não informado",
        classificacao_FinPec: clientsTest[i].personne_profile ? clientsTest[i].personne_profile.name : "Não informado",
        classificacao_banco: clientsTest[i].investor_profiles ? clientsTest[i].investor_profiles.name : "Não informado",
        telefone,
        email,
        marital: clientsTest[i].marital ? clientsTest[i].marital : "Não informado",
      })
      cpf = "Não informado"
    }
    
    setClientsExcel(FinalClient)
  }

  const handleSetAttributes = useCallback(async (client) => {
    try {
      setClientAmount(null);
      const response = await GetFetch(`/subscription/showPersonne?id=${client.id}&account=true`);
      setClientsAttributes(response?.data[0]);
      toggle()
    } catch (error) {
     
    }
  });

  async function handleAccountAmount() {
    if (clientsAttributes?.bank_accounts.length < 0) return
    setLoadingClientAmount(true);
    try {
      const response = await api.post(`/subscription/brp/showAccountAmount`, clientsAttributes.bank_accounts[0]);
      setClientAmount(response.data.bank_account_amount);
      console.log(response.data.bank_account_amount);

      setLoadingClientAmount(false);
    } catch (error) {
      console.log(error)
      setLoadingClientAmount(false)
    }
  }

  function handleQuery(word) {
    console.log(word)
    if (word.length >= 3) {
      setQuery(word)
      setCurrentPage(1)
    } else {
      setQuery('')
    }
  }

  const getClients = async () => {
    setLoading(true)
    try {
      const classificationResponse = await GetFetch(`/subscription/personne-classification`);
      const classificationList = classificationResponse.data;
      
      const response = await GetFetch(`/subscription/personne?page=${currentPage}&limit=${limit}&name=${query}${filterValues}${orderingValues}`);
      setTotalPages(response.data.lastPage);
      const responseClients = response.data.data;
      responseClients.map((client) => {
        client.personne_classification_name = classificationList.find((classification) => classification.id === client.personne_classification_id)?.name
      })

      setClients(responseClients);
      let clientsTest = response.data.data
      handleCreateNewJson(clientsTest)
      setError(false)

      if (response.data.total < 1) {
        enqueueSnackbar('Não existem clientes com o filtro escolhido', { variant: 'error' });
      }
    } catch (error) {
      setError(true)
      enqueueSnackbar('Ocorreu um erro ao carregar a lista dos clientes', { variant: 'error' });
    } finally { 
      setLoading(false)
    }
  };

  const tableComponent = () => {
    return (
      <Box>
        {clients && clients.length > 0
          ? 
          <>
            <CustomizedTables
              data={clients}
              columns={COLUMNSTABLE}
              options
              action={handleSetAttributes}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              No momento não existem clientes para listar
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  const exportExcelComponent = () => {
    return (
      <ExcelFile element={
        <Button variant="contained">Exportar para Excel</Button>
      } filename="Clientes">
        <ExcelSheet data={clientsExcel} name="Clientes">
          <ExcelColumn label="CPF/CNPJ" value='cpf'/>
          <ExcelColumn label="Nome" value="name"/>
          <ExcelColumn label="Sexo" value="gender"/>
          <ExcelColumn label="Aniversário" value="birth_date"/>
          <ExcelColumn label="Rua" value="rua" />
          <ExcelColumn label="Numero" value='numero' />
          <ExcelColumn label="CEP" value='cep' />
          <ExcelColumn label="Cidade" value='cidade' />
          <ExcelColumn label="Estado" value='estado' />
          <ExcelColumn label="documento_tipo_1" value={(col) => col.documento.length > 0 ? col.documento[0].type: "Não informado"} />
          <ExcelColumn label="documento_numero_1" value={(col) => col.documento.length > 0 ? col.documento[0].document_number: "Não informado"} />
          <ExcelColumn label="documento_orgão_1" value={(col) => col.documento.length > 0 ? col.documento[0].agency_issuing: "Não informado"} />
          <ExcelColumn label="documento_uf_1" value={(col) => col.documento.length > 0 ? col.documento[0].state: "Não informado"} />
          <ExcelColumn label="documento_tipo_2" value={(col) => col.documento.length > 1 ? col.documento[1].type: "Não informado"} />
          <ExcelColumn label="documento_numero_2" value={(col) => col.documento.length > 1 ? col.documento[1].document_number: "Não informado"} />
          <ExcelColumn label="documento_orgão_2" value={(col) => col.documento.length > 1 ? col.documento[1].agency_issuing: "Não informado"} />
          <ExcelColumn label="documento_uf_2" value={(col) => col.documento.length > 1 ? col.documento[1].state: "Não informado"} />
          <ExcelColumn label="documento_tipo_3" value={(col) => col.documento.length > 2 ? col.documento[2].type: "Não informado"} />
          <ExcelColumn label="documento_numero_3" value={(col) => col.documento.length > 2 ? col.documento[2].document_number: "Não informado"} />
          <ExcelColumn label="documento_orgão_3" value={(col) => col.documento.length > 2 ? col.documento[2].agency_issuing: "Não informado"} />
          <ExcelColumn label="documento_uf_3" value={(col) => col.documento.length > 2 ? col.documento[2].state: "Não informado"} />
          <ExcelColumn label="nascionalidade" value='nationality' />
          <ExcelColumn label="profissao" value='profession' />
          <ExcelColumn label="classificacao_FinPec" value='classificacao_FinPec' />
          <ExcelColumn label="classificacao_banco" value='classificacao_banco' />
          <ExcelColumn label="telefone_1" value={(col) => col.telefone.length > 0 ? `${col.telefone[0].country}${col.telefone[0].area}${col.telefone[0].phone_number}`  : "Não informado"} />
          <ExcelColumn label="telefone_2" value={(col) => col.telefone.length > 1 ? `${col.telefone[1].country}${col.telefone[1].area}${col.telefone[1].phone_number}`  : "Não informado"} />
          <ExcelColumn label="telefone_3" value={(col) => col.telefone.length > 2 ? `${col.telefone[2].country}${col.telefone[2].area}${col.telefone[2].phone_number}`  : "Não informado"} />
          <ExcelColumn label="email_1" value={(col) => col.email.length > 0 ? col.email[0].email : "Não informado"} />
          <ExcelColumn label="email_2" value={(col) => col.email.length > 1 ? col.email[1].email : "Não informado"} />
          <ExcelColumn label="estado_civil" value='marital' />
        </ExcelSheet>
      </ExcelFile>
    )
  }

  const getClassification = async () => {
    try {
      console.log("BUSCANDO CLASSIFICACOES");
      const response = await GetFetch(`/subscription/personne-classification`);
      setAvailableClassifications(response.data);
    } catch (error) { 
      console.log(error)
    }
  }

  useEffect(() => {

    getClassification();
    getClients();
    
  }, [
    currentPage,
    filterValues,
    filter,
    ordering,
    orderingValues,
    query
  ]);

  useEffect(() => {

    handleAccountAmount();

  }, [clientsAttributes])

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Clientes
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
            <Box
              component="form"
              autoComplete="off"
              sx={{
              width: '100%',
              maxWidth: '60%',
              }}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  label="Buscar por investidor"
                  variant="outlined"
                  defaultValue=''
                  onChange={event => handleQuery(event.target.value)} />
              </FormControl>
            </Box>
              
            <Box>
              <Button variant="contained" sx={{ marginRight: 2}} color="success" onClick={toggleOpenModalNew}>Novo</Button>
              {filter ?
                <Button variant="contained" sx={{ marginRight: 2}} color="error" onClick={handleClearFilter}>Limpar filtros</Button>
                :
                <Button variant="contained" sx={{ marginRight: 2 }} onClick={handleOpen}>Filtros</Button>
              }
              {ordering ?
                <Button variant="contained" sx={{ marginRight: 2}} color="error" onClick={handleClearOrder}>Limpar ordenação</Button>
                :
                <Button variant="contained" sx={{ marginRight: 2 }} onClick={toggleOpenModalOrdering}>Ordenação</Button>
              }
              {exportExcelComponent()}
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openFilterModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <FilterModal
          setFilter={setFilter}
          setFilterValues={setFilterValues}
          onClose={handleClose}
          availableClassifications={availableClassifications}
        />
      </Modal>

      <Modal
        open={openModalOrdering}
        onClose={toggleOpenModalOrdering}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <OrderModal
          setOrdering={setOrdering}
          setOrderValues={setOrderingValues}
          onClose={toggleOpenModalOrdering}
        />
      </Modal>

      <Modal
        open={modal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DetailsClientModal
          client={clientsAttributes}
          onClose={toggle}
          loadingClientAmount={loadingClientAmount}
          clientAmount={clientAmount}
          clientClassifications={availableClassifications}
          updateClientList={getClients}
        />
      </Modal>

      <Modal
        open={openModalNew}
        onClose={toggleOpenModalNew}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NewClientModal
          onClose={toggleOpenModalNew}
          getList={getClients}
        />
      </Modal>
    </>
  );
}

export default ClientList;
